import React, { lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Main from './layouts/Main'; // fallback for lazy pages
import './static/css/main.scss'; // All of our styles
import Flashcard from './components/utils/Flashcard';
import LinkedInPostPopup from './components/utils/LinkedInPostPopup';

const { PUBLIC_URL } = process.env;

// Every route - we lazy load so that each page can be chunked
// NOTE that some of these chunks are very small. We should optimize
// which pages are lazy loaded in the future.
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const Index = lazy(() => import('./pages/Index'));
const NotFound = lazy(() => import('./pages/NotFound'));
const Projects = lazy(() => import('./pages/Projects'));
const Resume = lazy(() => import('./pages/Resume'));
const API = lazy(() => import('./pages/API'));
const AIChatBot = lazy(() => import('./pages/AI/ChatBot'));
const AIChatWithCharacter = lazy(() => import('./pages/AI/ChatWithCharacter'));
const AIGenerate = lazy(() => import('./pages/AI/Generate'));
const AIGenerateImage = lazy(() => import('./pages/AI/GenerateImage'));
const AIAll = lazy(() => import('./pages/AI/all'));
const App = () => (
  <BrowserRouter basename={PUBLIC_URL}>
    <Flashcard />
    <LinkedInPostPopup />
    <Routes>
      <Route element={<Main />}>
        <Route path="/" element={<Index />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/API" element={<API />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/ai/chatbot" element={<AIChatBot />} />
        <Route path="/ai/generate" element={<AIGenerate />} />
        <Route path="/ai/generateimage" element={<AIGenerateImage />} />
        <Route path="/ai/all" element={<AIAll />} />
        <Route path="/ai/chat/:character" element={<AIChatWithCharacter />} />
        <Route path="/ai/chat" element={<AIChatWithCharacter />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  </BrowserRouter>
);

export default App;
